/**
 * The buyer-facing "repriced for quote/checkout" note (UID-139, ADR-0061
 * Decision 4) — one small component so the cart rail, the Generate-quote
 * modal, and the checkout rail render the disclosure identically and can't
 * drift. The actual copy lives in `lib/pricing-copy.ts`; this owns the shared
 * markup/styling (`.pricing-reprice-note`, a WCAG-AA-contrast caption).
 */
export interface RepriceNoteProps {
  /** One of the `PRICING_*_NOTE` constants from `lib/pricing-copy`. */
  readonly note: string
}

export function RepriceNote({ note }: RepriceNoteProps) {
  return <p className="caption-text pricing-reprice-note">{note}</p>
}
